import { useEffect, useRef, useState } from "react";
import TableData from "./TableData";
import "./productDetail.css";
import DownArrow from "../../assets/filterArrowDown.svg";
import UpArrow from "../../assets/filterArrowUp.svg";
import { useDispatch } from "react-redux";
import { productList } from "../../redux/actions/productActions";
import ErrorPopup from "../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../components/utilites/loader";
import { useNavigate } from "react-router-dom";
import NumberPagination from "../../components/Pagination/number-pagination";

const ProductsTable = ({ search, status, page_no }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const componentRef = useRef(null);
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [productListData, setPorductList] = useState([]);
  const [openStatus, setOpenStatus] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    setLoading(true);
    dispatch(
      productList(
        {
          search,
          status:
            status === "active" ? true : status === "inactive" ? false : null,
          page,
        },
        onSuccess,
        onError
      )
    );
  }, [page, search, status]);

  const fetchProductList = () => {
    dispatch(
      productList(
        {
          search,
          status:
            status === "active" ? true : status === "inactive" ? false : null,
          page,
        },
        onSuccess,
        onError
      )
    );
  };

  const onSuccess = (data) => {
    setLoading(false);
    setPorductList(data.data.data);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    setLoading(false);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setOpenStatus(false);
    }
  };

  useEffect(() => {
    if (openStatus) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [openStatus]);

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);
  if (status) queryParams.push(`status=${status}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <>
      <div>
        <div className="table-container text-nowrap">
          <table className="main-table">
            <thead>
              <tr className="table-rows">
                <th className="table-heads " width={"4%"}>
                  #
                </th>
                <th className="table-heads" width={"11%"}>
                  Product ID
                </th>
                <th className="table-heads" width={"13%"}>
                  Company’s Product ID
                </th>
                <th className="table-heads" width={"15%"}>
                  Product Name
                </th>
                <th className="table-heads" width={"12%"}>
                  Division Name
                </th>
                <th
                  ref={componentRef}
                  className="table-heads cursor_pointer"
                  width={"12%"}
                >
                  <span
                    onClick={() => setOpenStatus(!openStatus)}
                    className={
                      openStatus
                        ? "Medium_Purple cursor_pointer"
                        : "cursor_pointer"
                    }
                  >
                    <span className={status ? "Medium_Purple fw_700" : ""}>
                      Status
                    </span>
                    {openStatus ? (
                      <img src={UpArrow} className="mb-1 mx-1" alt="v" />
                    ) : (
                      <img src={DownArrow} className=" mx-1" alt="v" />
                    )}
                  </span>
                  {openStatus ? (
                    <div className=" position-relative">
                      <div className="position-absolute status-container d-flex gap-3 px-3">
                        <div className="d-flex align-items-center ">
                          <input
                            className="radio me-2"
                            type="radio"
                            id="active"
                            name="area_covered"
                            value={"active"}
                            checked={status === "active"}
                            onClick={(e) => {
                              setOpenStatus(!openStatus);
                              navigate(
                                `/product?page=1${
                                  search ? `&search=${search}` : ""
                                }&status=active`
                              );
                            }}
                          />
                          <label
                            htmlFor="active"
                            className={
                              status === "active"
                                ? "color_262c3d cursor_pointer"
                                : "color_747f9e cursor_pointer"
                            }
                          >
                            Active
                          </label>
                        </div>
                        <div className="d-flex align-items-center ">
                          <input
                            className="radio me-2"
                            type="radio"
                            id="inactive"
                            name="area_covered"
                            value={"inactive"}
                            checked={status === "inactive"}
                            onClick={(e) => {
                              setOpenStatus(!openStatus);
                              navigate(
                                `/product?page=1${
                                  search ? `&search=${search}` : ""
                                }&status=inactive`
                              );
                            }}
                          />
                          <label
                            htmlFor="inactive"
                            className={
                              status === "inactive"
                                ? "color_262c3d cursor_pointer"
                                : "color_747f9e cursor_pointer"
                            }
                          >
                            Inactive
                          </label>
                        </div>
                        <button
                          className="filter-btn px-2 py-0 my-2 fs_12"
                          style={{ height: "28px" }}
                          onClick={() => {
                            setOpenStatus(!openStatus);
                            navigate(
                              `/product?page=1${
                                search ? `&search=${search}` : ""
                              }`
                            );
                          }}
                        >
                          CLEAR
                        </button>
                      </div>
                    </div>
                  ) : null}
                </th>
                <th className="table-heads-action" width={"10%"}>
                  Offer Type
                </th>
                <th className="table-heads-action" width={"25%"}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody style={{ position: "relative" }}>
              {loading === true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : productListData?.products?.length > 0 ? (
                <>
                  {productListData?.products?.map((eachRow, index) => (
                    <TableData
                      key={eachRow.id}
                      data={eachRow}
                      index={index + 1}
                      fetchProductList={fetchProductList}
                      currentPage={productListData?.pagination?.currentPage}
                    />
                  ))}
                </>
              ) : (
                <tr>
                  <td
                    colSpan="1"
                    className="text-center no-data-container fs_16"
                  >
                    <span>~ No Data Found ~</span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className={loading === true ? `loading-event` : ""}>
          {productListData?.pagination?.totalPages > 0 && (
            <NumberPagination
              setCurrentPage={setPage}
              pagination={productListData?.pagination?.currentPage}
              totalPages={productListData?.pagination?.totalPages}
              path={"/product"}
              filters={`${queryString}`}
            />
          )}
        </div>
        <ErrorPopup
          show={showErrorPopup}
          title={showErrorMsg}
          handleClose={closeErrorPopup}
        />
      </div>
    </>
  );
};

export default ProductsTable;
